import { actionTypes } from "../../shell/actions";
import get from 'lodash/get';

const deafultState = {
  token: '',
  sftoken: '',
  loading: false,
  error: false,
  birthPlaces: [], // TODO: remove redux when no component use anymore
  regencies: [], // TODO: remove redux when no component use anymore
  villages: [], // TODO: remove redux when no component use anymore
  plan: {},
  order: {},
  banks: [],
  leadResponse: {},
  navigationItems: [],
  locationList: [],
  relatedArticles: [],
  fileUploadProgress: '',
};

/**
 *
 * @param {Object} state - Redux state
 * @param {Object} response - server response
 */

function normalizeDataList(dataList = []) {
  return dataList.map(row => ({ label: row.name, value: row.id }));
}

function normalizeRelatedArticles(dataList = []) {
  if (!dataList.length) return dataList;

  return dataList.map(item => ({
    title: get(item, 'title', ''),
    slug: get(item, 'slug', ''),
  }));
}


export default function sharedReducers(state = deafultState, action) {
  switch (action.type) {
    case actionTypes.LOADING_BIRTH_PLACES:
      return {
        ...state,
        loading: true,
      }
    case actionTypes.LOADED_BIRTH_PLACES:
      return {
        ...state,
        loading: false,
        birthPlaces: normalizeDataList(action.payload.response.data),
      }
    case actionTypes.ERROR_LOADING_BIRTH_PLACES:
      return {
        ...state,
        loading: false,
        error: true,
      }
    case actionTypes.LOADING_REGENCIES:
      return {
        ...state,
        loading: true,
      }
    case actionTypes.LOADED_REGENCIES:
      return {
        ...state,
        loading: false,
        regencies: normalizeDataList(action.payload.response.data),
      }
    case actionTypes.ERROR_LOADING_REGENCIES:
      return {
        ...state,
        loading: false,
        error: true,
      }
    case actionTypes.LOADING_VILLAGES:
      return {
        ...state,
        loading: true,
      }
    case actionTypes.LOADED_VILLAGES:
      return {
        ...state,
        loading: false,
        villages: normalizeDataList(action.payload.response.data),
      }
    case actionTypes.ERROR_LOADING_VILLAGES:
      return {
        ...state,
        loading: false,
        error: true,
      }
    case actionTypes.LOADING_BANKS:
      return {
        ...state,
        loading: true,
      }
    case actionTypes.LOADED_BANKS:
      const normalizeBanks = action.payload.banks.data.map(row => ({
        label: row.bankName,
        value: row.bankCode,
        code: row.xenditBankCode,
      }));

      return {
        ...state,
        loading: false,
        banks: normalizeBanks,
      }
    case actionTypes.ERROR_LOADING_BANKS:
      return {
        ...state,
        loading: false,
        error: true,
      }

    case actionTypes.SUBMITING_LEADS:
      return {
        ...state,
        loading: true,
      }
    case actionTypes.SUBMITTED_LEADS:
      return {
        ...state,
        loading: false,
        leadResponse: action.payload.leads.data,
      }
    case actionTypes.ERROR_SUBMITTING_LEADS:
      return {
        ...state,
        loading: false,
        error: true,
      }
    case actionTypes.RESET_LEADS:
      return {
        ...state,
        leadResponse: {},
      }
    case actionTypes.LOADING_NAVIGATION_ITEMS:
      return {
        ...state,
        loading: true,
      }
    case actionTypes.LOADED_NAVIGATION_ITEMS:
      return {
        ...state,
        loading: false,
        navigationItems: action.payload.navigationItems.data,
      }
    case actionTypes.ERROR_LOADING_NAVIGATION_ITEMS:
      return {
        ...state,
        loading: false,
        error: true,
      }
    case actionTypes.LOADING_LOCATION_LIST:
      return {
        ...state,
        loading: true,
      }
    case actionTypes.LOADED_LOCATION_LIST:
      return {
        ...state,
        loading: false,
        locationList: action.payload.locations.data,
      }
    case actionTypes.ERROR_LOADING_LOCATION_LIST:
      return {
        ...state,
        loading: false,
        error: true,
      }
    case actionTypes.RESET_LOCATION_LIST:
      return {
        ...state,
        locationList: [],
      }
    case actionTypes.RESET_LEAD_RESPONSE:
      return {
        ...state,
        leadResponse: {},
      }
    case actionTypes.SUBMITTING_FINANCIAL_CHECKUP:
      return {
        ...state,
        loading: true,
      }
    case actionTypes.SUBMITTED_FINANCIAL_CHECKUP:
      return {
        ...state,
        loading: false,
      }
    case actionTypes.ERROR_SUBMITTING_FINANCIAL_CHECKUP:
      return {
        ...state,
        loading: false,
        error: true,
      }
    case actionTypes.LOADING_RELATED_ARTICLES:
      return {
        ...state,
        loading: true,
      }
    case actionTypes.LOADED_RELATED_ARTICLES:
      return {
        ...state,
        loading: false,
        relatedArticles: normalizeRelatedArticles(action.payload),
      }
    case actionTypes.ERROR_LOADING_RELATED_ARTICLES:
      return {
        ...state,
        loading: false,
        error: true,
      }
    case actionTypes.LOADING_CALCULATOR_ARTICLES:
      return {
        ...state,
        loading: true,
      }
    case actionTypes.LOADED_CALCULATOR_ARTICLES:
      return {
        ...state,
        loading: false,
        calculatorArticles: normalizeRelatedArticles(action.payload),
      }
    case actionTypes.ERROR_LOADING_CALCULATOR_ARTICLES:
      return {
        ...state,
        loading: false,
        error: true,
      }
    case actionTypes.UPLOAD_FILES_START:
      return {
        ...state,
        loading: true,
      }
    case actionTypes.UPLOAD_FILES_SUCCESS:
      return {
        ...state,
        loading: false,
        fileUploadProgress: ''
      }
    case actionTypes.UPLOAD_FILES_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        fileUploadProgress: ''
      }
    case actionTypes.UPLOAD_FILES_PROGRESS:
      return {
        ...state,
        fileUploadProgress: action.payload
      }
    case actionTypes.LOADING_SALESFORCE_TOKEN:
      return {
        ...state,
        loading: true,
      }
    case actionTypes.ERROR_LOADING_SALESFORCE_TOKEN:
      return {
        ...state,
        loading: false,
        error: true
      }
    case actionTypes.LOADED_SALESFORCE_TOKEN:
      return {
        ...state,
        loading: false,
        sftoken: action.payload
      }
    default:
      return state;
  }
}
